import {
  Uil500px,
  UilAirplay,
  UilArrowGrowth,
  UilBriefcase,
  UilFolder,
  UilFolderLock,
  UilUserCircle,
  UilAt,
  UilBagAlt,
  UilBookAlt,
  UilBookOpen,
  UilBookReader,
  UilCalendarAlt,
  UilChartBar,
  UilChat,
  UilCheckSquare,
  UilCircle,
  UilClipboardAlt,
  UilClock,
  UilCompactDisc,
  UilCreateDashboard,
  UilDatabase,
  UilDocumentLayoutLeft,
  UilEdit,
  UilEnvelope,
  UilExchange,
  UilExclamationOctagon,
  // UilExpandArrowsAlt,
  UilFile,
  UilFileShieldAlt,
  UilHeadphones,
  UilIcons,
  UilImages,
  UilLayerGroup,
  UilMap,
  UilPresentation,
  UilQuestionCircle,
  UilSearch,
  UilServer,
  UilSetting,
  UilShoppingCart,
  UilSquareFull,
  UilTable,
  UilUsdCircle,
  UilUsersAlt,
  UilWindowSection,
  UilInvoice,
  UilHourglass,
  UilKeySkeleton,
  UilMoneyInsert,
  UilTransaction,
  UilTag,
} from '@iconscout/react-unicons';
import { Menu } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import propTypes from 'prop-types';
import { NavTitle } from './Style';
import versions from '../demoData/changelog.json';
import { changeDirectionMode, changeLayoutMode, changeMenuMode } from '../redux/themeLayout/actionCreator';
import { getItem as getLocalStoreItem } from '../utility/localStorageControl';
import ExternalLinkIcon from '../components/icons/ExternalLinkIcon';

function MenuItems({ toggleCollapsed }) {
  const { t } = useTranslation();
  const userData = getLocalStoreItem('user_data');

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const { topMenu } = useSelector((state) => {
    return {
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });

  const dispatch = useDispatch();

  const path = '';

  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1] ?? '';
  const mainPathSplit = mainPath.split('/');

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  const changeLayout = (mode) => {
    dispatch(changeLayoutMode(mode));
  };
  const changeNavbar = (topMode) => {
    const html = document.querySelector('html');
    if (topMode) {
      html.classList.add('hexadash-topmenu');
    } else {
      html.classList.remove('hexadash-topmenu');
    }
    dispatch(changeMenuMode(topMode));
  };
  const changeLayoutDirection = (rtlMode) => {
    if (rtlMode) {
      const html = document.querySelector('html');
      html.setAttribute('dir', 'rtl');
    } else {
      const html = document.querySelector('html');
      html.setAttribute('dir', 'ltr');
    }
    dispatch(changeDirectionMode(rtlMode));
  };

  const darkmodeActivated = () => {
    document.body.classList.add('dark');
  };

  const darkmodeDiactivated = () => {
    document.body.classList.remove('dark');
  };

  const items = [
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/admin`}>
        {t('Dashboard')}
        {/* <span className="badge badge-primary menuItem">{12}</span> */}
      </NavLink>,
      'Dashboard',
      !topMenu && <UilArrowGrowth />,
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/domains`}>
        {t('Domeny')}
        {/* <span className="badge badge-primary menuItem">{12}</span> */}
      </NavLink>,
      'domains-main',
      !topMenu && <UilFolder />,
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/futures`}>
        {t('Opcje')}
        {/* <span className="badge badge-primary menuItem">{0}</span> */}
      </NavLink>,
      'Futures',
      !topMenu && <UilFolderLock />,
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/pricing`}>
        {t('Cennik')}
        {/* <span className="badge badge-primary menuItem">{12}</span> */}
      </NavLink>,
      'Cennik',
      !topMenu && <UilInvoice />,
    ),

    getItem(
      <NavLink onClick={toggleCollapsed} to={`/contacts`}>
        {t('Profile danych')}
        {/* <span className="badge badge-primary menuItem">{12}</span> */}
      </NavLink>,
      'Profile danych',
      !topMenu && <UilUserCircle />,
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/tags`}>
        {t('Tagi')}
      </NavLink>,
      'tags',
      !topMenu && <UilTag />,
    ),

    getItem(
      <NavLink onClick={toggleCollapsed} target="_blank" to={`https://dns.pl/whois`}>
        {t('Whois')}
        <ExternalLinkIcon className="w-3 h-3 inline-block ml-[6px] align-middle" />
        {/* <span className="badge badge-primary menuItem">{12}</span> */}
      </NavLink>,
      'Whois',
      !topMenu && <UilSearch />,
    ),

    getItem(
      !topMenu && (
        <NavTitle className="flex text-[12px] font-medium uppercase text-light mt-[20px] dark:text-white87 p-0">
          {t('Przechwytywanie domen')}
        </NavTitle>
      ),
      'interceptions',
      null,
      null,
      'group',
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/interceptions/domains`}>
        {t('Aktywne zlecenia')}
        {/* <span className="badge badge-primary menuItem">{12}</span> */}
      </NavLink>,
      'domains-interceptions',
      !topMenu && <UilFolder />,
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/interceptions/domains/expiring`}>
        {t('Wygasające domeny')}
        {/* <span className="badge badge-primary menuItem">{12}</span> */}
      </NavLink>,
      'domains-interceptions-expiring',
      !topMenu && <UilHourglass />,
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/auctions`}>
        {t('Trwające aukcje')}
        {/* <span className="badge badge-primary menuItem">{12}</span> */}
      </NavLink>,
      'auctions',
      !topMenu && <UilBriefcase />,
    ),
    // getItem(
    //   <NavLink onClick={toggleCollapsed} to={`/interceptions/futures`}>
    //     {t('Opcje')}
    //     {/* <span className="badge badge-primary menuItem">{0}</span> */}
    //   </NavLink>,
    //   'Futures',
    //   !topMenu && <UilFolderLock />,
    // ),

    getItem(
      !topMenu && (
        <NavTitle className="flex text-[12px] font-medium uppercase text-light mt-[20px] dark:text-white87 p-0">
          {t('Konto')}
        </NavTitle>
      ),
      'user-account',
      null,
      null,
      'group',
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/profile/account`}>
        {t('Ustawienia konta')}
      </NavLink>,
      'account-settings',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`/profile/account`}>
          <UilSetting />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/profile/notification`}>
        {t('Powiadomienia')}
      </NavLink>,
      'notifications-settings',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`/profile/notification`}>
          <UilEnvelope />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/api-keys`}>
        {t('API')}
      </NavLink>,
      'api',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`/api-keys`}>
          <UilKeySkeleton />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/balances/topups`}>
        {t('Zasilenia')}
      </NavLink>,
      'Zasilenia',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`/balances/topups`}>
          <UilMoneyInsert />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`/balances/transactions`}>
        {t('Transakcje')}
      </NavLink>,
      'Transakcje',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`/balances/transactions`}>
          <UilTransaction />
        </NavLink>
      ),
    ),

    /**
     * @documentation
     * Celem ogranicznia widocznosci elementów menu w zależności od uprawnień użytkownika wykorzystujemy obiekt userData
     * userData?.beta_tester - pozwala na wyświetlenie elementów menu tylko dla beta testerów
     */
    ...(userData?.beta_tester ? [] : []),
  ];

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<UilEllipsisV />}
      openKeys={openKeys}
      items={items}
    />
  );
}

MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
